module.exports = __webpack_public_path__ + "img/Mike-Berkowitz.03b74243.jpg";